import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _03572474 = () => interopDefault(import('../views/home.vue' /* webpackChunkName: "" */))
const _41b2276a = () => interopDefault(import('../views/vehicle/index.vue' /* webpackChunkName: "" */))
const _52b9bbd6 = () => interopDefault(import('../views/vehicle/show.vue' /* webpackChunkName: "" */))
const _1c471094 = () => interopDefault(import('../views/vehicle/create.vue' /* webpackChunkName: "" */))
const _712db1a3 = () => interopDefault(import('../views/vehicle/author.vue' /* webpackChunkName: "" */))
const _2b5f1fb6 = () => interopDefault(import('../views/user/dashboard.vue' /* webpackChunkName: "" */))
const _4a5266a2 = () => interopDefault(import('../views/vehicle/edit.vue' /* webpackChunkName: "" */))
const _bedb320c = () => interopDefault(import('../views/user/login.vue' /* webpackChunkName: "" */))
const _a962d0bc = () => interopDefault(import('../views/user/register.vue' /* webpackChunkName: "" */))
const _387051ee = () => interopDefault(import('../views/user/edit.vue' /* webpackChunkName: "" */))
const _5b6db31b = () => interopDefault(import('../views/user/resetPassword.vue' /* webpackChunkName: "" */))
const _258a5a01 = () => interopDefault(import('../views/user/googleLogin.vue' /* webpackChunkName: "" */))
const _ea11098a = () => interopDefault(import('../views/info/terms.vue' /* webpackChunkName: "" */))
const _735127ae = () => interopDefault(import('../views/info/policy.vue' /* webpackChunkName: "" */))
const _7acf2a54 = () => interopDefault(import('../views/info/contact.vue' /* webpackChunkName: "" */))
const _75a745c1 = () => interopDefault(import('../views/plan/index.vue' /* webpackChunkName: "" */))
const _6cf55cde = () => interopDefault(import('../views/plan/show.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/",
    component: _03572474,
    name: "home"
  }, {
    path: "/listado",
    component: _41b2276a,
    name: "vehicle.index"
  }, {
    path: "/vehiculos/:slug",
    component: _52b9bbd6,
    name: "vehicle.show"
  }, {
    path: "/publicar",
    component: _1c471094,
    name: "vehicle.create"
  }, {
    path: "/autor/:slug",
    component: _712db1a3,
    name: "vehicle.author"
  }, {
    path: "/mis-vehiculos",
    component: _2b5f1fb6,
    name: "user.dashboard"
  }, {
    path: "/mis-vehiculos/editar/:slug",
    component: _4a5266a2,
    name: "vehicle.edit"
  }, {
    path: "/ingresar",
    component: _bedb320c,
    name: "user.login"
  }, {
    path: "/registrarse",
    component: _a962d0bc,
    name: "user.register"
  }, {
    path: "/usuario/editar",
    component: _387051ee,
    name: "user.edit"
  }, {
    path: "/restablecer",
    component: _5b6db31b,
    name: "user.resetPassword"
  }, {
    path: "/google-login",
    component: _258a5a01,
    name: "google-login"
  }, {
    path: "/terminos-y-condiciones",
    component: _ea11098a,
    name: "info.terms"
  }, {
    path: "/politica-de-privacidad",
    component: _735127ae,
    name: "info.policy"
  }, {
    path: "/contacto",
    component: _7acf2a54,
    name: "info.contact"
  }, {
    path: "/planes",
    component: _75a745c1,
    name: "plan.index"
  }, {
    path: "/planes/:slug",
    component: _6cf55cde,
    name: "plan.show"
  }, {
    path: "/vehiculos",
    redirect: "/listado"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
